import { combineReducers } from 'redux';
import featureValues from './featureValues';
import toasts from './toasts';
import redirect from './redirect';
import tokens from './tokens';
import user from './user';

export default combineReducers({
  featureValues,
  redirect,
  toasts,
  tokens,
  user,
});
